const sortAlphabetically = (array, property) =>
  array.sort((firstObj, secondObj) => {
    const firstString = firstObj[property].toLowerCase();
    const secondString = secondObj[property].toLowerCase();

    if (firstString > secondString) {
      return 1;
    }
    if (firstString < secondString) {
      return -1;
    }
    return 0;
  });

const sortDatesAscending = (array, property) =>
  array.sort((first, second) => {
    const firstDate = new Date(first[property]);
    const secondDate = new Date(second[property]);
    return firstDate - secondDate;
  });

export { sortAlphabetically, sortDatesAscending };
